module.exports = __webpack_public_path__ + "aa23623659c292e4d97a231e8f4d0d96.jpg";